module.exports = __webpack_public_path__ + "img/icon-account-phone-green@3x.995e9802.png";